import React, { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button, Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

const SignatureWidget = (props) => {
  const { id } = useParams();
  const { value, onChange, label } = props;
  const sigCanvasRef = useRef();

  const handleClear = () => {
    sigCanvasRef.current.clear();
    onChange(undefined);
  };

  const handleEnd = () => {
    if (!sigCanvasRef.current.isEmpty()) {
      const dataUrl = sigCanvasRef.current.toDataURL("image/png");
      onChange(dataUrl);
    } else {
      onChange(undefined);
    }
  };

  useEffect(() => {
    if (value && sigCanvasRef?.current) {
      if (sigCanvasRef?.current) {
        if (id) {
          sigCanvasRef.current.off(); // Disable drawing
        }
        setTimeout(() => {
            try {
              sigCanvasRef.current?.clear();
              sigCanvasRef.current?.fromDataURL(value);
            } catch (error) {
              console.error("Failed to load signature:", error);
            }
          }, 100);
      }
    }
  }, [value, id]);

  return (
    <Box sx={{
          border: "1px solid #ccc",
          borderRadius: 2,
          padding: 2,
          mt: 2,
        }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {label}
      </Typography>

      <SignatureCanvas
        penColor="black"
        canvasProps={{          
          width: 400,
          height: 150,
          className: "sigCanvas",
          style: { border: "1px solid #ccc", borderRadius: "4px",maxWidth: "100%" },
        }}
        ref={sigCanvasRef}
        onEnd={handleEnd}
      />

      <Box sx={{ mt: 1 }}>
        <Button
          disabled={id ? true : false}
          variant="outlined"
          onClick={handleClear}
        >
          Clear
        </Button>
      </Box>
    </Box>
  );
};

export default SignatureWidget;
